import requests from "./httpService";

const VehicleServices = {

    getVehicle: async () =>{
        return requests.get(`/model`);
    },
    updateVehicle : async (id,body) =>{
     
        return requests.patch(`/model/${id}`,body);
    },

    createVehicle : async (body) =>{
     
        return requests.post(`/model`,body);
    },
    deleteVehicle : async (id) =>{
        return requests.delete(`/model/${id}`);
    }
  

}
export default VehicleServices;